<template>
  <header class=" sticky top-0 left-0 w-full z-50 bg-white shadow-md">
    <nav class="max-w-7xl mx-auto flex justify-between items-center px-8 py-0">
      <!-- Logo -->
      <router-link to="/">
        <img src="./assets/logo.png" alt="Logo" class="h-16 w-auto" />
      </router-link>

      <!-- Hamburger Icon (Mobile only) -->
      <button @click="isOpen = !isOpen" class="lg:hidden text-2xl focus:outline-none">
        ☰
      </button>

      <!-- Desktop Nav -->
      <ul class="hidden lg:flex gap-6 items-center text-gray-700 text-[15px] font-medium">
        <li><router-link to="/" class="hover:text-black transition">Home</router-link></li>
        <li><router-link to="/about-us" class="hover:text-black transition">About Us</router-link></li>
        <li><router-link to="/products" class="hover:text-black transition">Products</router-link></li>
        <li><a href="https://shvasonsystems.zohorecruit.in/jobs/Careers" target="_blank" rel="noopener noreferrer">Careers</a></li>
        <li><router-link to="/contact-us" class="hover:text-black transition">Contact</router-link></li>
      </ul>
    </nav>

    <!-- Mobile Menu -->
    <div v-if="isOpen" class="lg:hidden px-6 pb-4 bg-white border-t">
      <ul class="flex flex-col gap-3 text-gray-700 text-[15px] font-medium">
        <li><router-link to="/" @click="isOpen = false">Home</router-link></li>
        <li><router-link to="/about-us" @click="isOpen = false">About Us</router-link></li>
        <li><router-link to="/products" @click="isOpen = false">Products</router-link></li>
        <li><a href="https://shvasonsystems.zohorecruit.in/jobs/Careers" target="_blank" rel="noopener">Careers</a></li>
        <li><router-link to="/contact-us" @click="isOpen = false">Contact</router-link></li>
      </ul>
    </div>
    <!-- Route content here -->

    <div class="font-sans">
    <router-view />
    </div>
    
  </header>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false
    };
  }
};
</script>



<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
